export default {
  accountDetails: 'Account details',
  notificationSettings: 'Notification settings',
  organisationDetails: 'Organisation details',
  organisationSettings: 'Organisation settings',
  userPermissions: 'User permissions',
  permissionsMatrix: 'Permissions matrix',
  roleCapabilities: 'Role capabilities',
  createNewOrg: 'Create New Organisation',
  orgChangeModal: {
    title: 'Changing Organisation',
    content: 'You will be directed back to the projects page.',
  },
  mobileOrientation: {
    title: 'Please rotate back to portrait for the best experience',
    dismiss: 'Tap to dismiss',
  },
  menu: 'Menu',
  close: 'Close',
  organisationSwitcher: {
    title: 'Switch organisation',
    subtitle: 'Pin the organisation you want to open on login.',
    setAsPrimary: 'Set as primary',
    primaryOrganisation: 'Primary organisation',
  },
};
